import { initLibs } from "@/global/lib";
import { loadMiddlewares } from "./middlewares";
import { setGlobalFlags } from "./flags";
import { initializeCelloIntegration } from "./lib/cello";

export const initGlobal = () => {
  initLibs();
  setGlobalFlags();
  loadMiddlewares();
};

export const initAuthLibraries = async (session, options = {}) => {
  const { shouldShowReferralLink = false } = options;

  if (shouldShowReferralLink) {
    await initializeCelloIntegration(session);
  }
};
